import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(): boolean {
    // First check if user is logged in with a valid token
    if (!this.authService.isLoggedIn()) {
      console.log('User not logged in or token expired');
      // this.router.navigate(['/login']);
      window.location.replace('/login');
      return false;
    }

    // Get user profile data
    const userProfile = this.authService.getUserProfile();

    // Check if email is missing (needs to be set)
    if (!userProfile.email) {
      console.log('Email not set, redirecting to change email page');
      this.router.navigate(['/changeEmail']);
      return true; // Allow navigation to change email
    }

    // Check if password change is required
    if (userProfile.changeFlag) {
      console.log('Password change required');
      this.router.navigate(['/profile']);
      return true; // Allow navigation to profile
    }

    // All checks passed
    return true;
  }
}
